import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import styled from 'styled-components';
import { UserListRadio } from './UserListRadio';

const StyledCodeDiv = styled.div`
  display: flex;
  justify-content: left;
  max-height: 20ch;
  overflow-y: auto;
`;

const UserListDialog = (props) => {
  const {users, onUserSelect,onClose,errorMessage} = props;
  const [open, setOpen] = useState(true);
  const [selectedUser, setSelectedUser] = useState('');

  const handleOk = () => {
    onUserSelect(selectedUser);
    handleClose();
  }
  const handleClose = () => {
    setOpen(false);
    onClose();
  }

  const onSelectUser = (userId) => setSelectedUser(userId);
    
    return (
        <Dialog
          sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
          maxWidth="xs"
          open={open}
        >
          <DialogTitle>Please select your name</DialogTitle>
          <DialogContent dividers>
            <StyledCodeDiv>
              <UserListRadio users={users} selectedUser ={selectedUser} onSelectUser={onSelectUser}/>
            </StyledCodeDiv>
          <DialogContentText style={{ color: 'red' }}>
            {errorMessage}
          </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleOk}>Ok</Button>
          </DialogActions>
        </Dialog>
      );
};

export { UserListDialog };
